<template>
    <div class="claims-compare">
        <slot name="tip" />
        <pre ref="compareResult" />
        <div v-if="loading" class="loading-box center">
            <Loading />
        </div>
    </div>
</template>

<script>
import CompareService from '@/services/compare-service';
import serviceInjectMixin from '@/mixins/serviceInject';
import loading from '../Loading';
import { CLMS_COMPARE_SERVICE, DESC_COMPARE_SERVICE } from '@/constants/index';
import { Toast } from 'patsnap-biz';

export default {
    name: 'TextCompare',
    components: {
        Loading: loading,
    },
    mixins: [
        serviceInjectMixin,
    ],
    props: {
        'from': {
            type: String, required: true,
        },
        'to': { // To是当前专利
            type: String,
        },
        'service': { // 区分claim / desc
            type: String,
        },
    },
    data() {
        return {
            loading: false,
            diffCount: 0,
        };
    },
    created() {
        switch (this.service) {
            case CLMS_COMPARE_SERVICE: // 需要比较的两个patentId
                this.type = 'clms';
                break;
            case DESC_COMPARE_SERVICE:
                this.type = 'desc';
                break;
        }
        this.fromService = new CompareService(this.from);
        this.toService = new CompareService(this.to);
        this.serviceInjectMixin_services.add(this.fromService);
        this.serviceInjectMixin_services.add(this.toService);
    },
    mounted() {
        this.compareRun()
            .catch(error => {
                console.error(error);
            });
    },
    methods: {
        closeErrCompare(text) {
            Toast({
                message: this.$t(`${this.service}['${text}']`),
                type: 'warning',
                showClose: true,
            });
            this.$emit('close');
        },
        async compareRun() {
            const vm = this;
            this.loading = true;
            try {
                const [fromTextData, toTextData] = await Promise.all([
                    this.fromService.getPureText(this.type),
                    this.toService.getPureText(this.type),
                ]);
                this.fromTextData = fromTextData;
                this.toTextData = toTextData;

            } catch (error) {
                console.error(error);
            }
            // 对比的专利无内容
            if (!this.fromTextData.str) {
                this.closeErrCompare('COMPARE_EMPTY');
                return;
            }
            // 对比的专利语言不同
            if (this.fromService.lang !== this.toService.lang) {
                this.closeErrCompare('COMPARE_DIFF_LANG');
                return;
            }
            const display = this.$refs.compareResult;
            const aSelfPid = this.to;
            const bSelfPid = this.from;
            const aClmsStr = this.toTextData.str; // 当前专利文本
            const bClmsStr = this.fromTextData.str; // 对比的专利文本
            const aSelfReplace = this.toTextData.relatedPatentId; // 替代文本的id
            const bSelfReplace = this.fromTextData.relatedPatentId;

            function selfHas(type) {
                if (type === 'a') {
                    return aClmsStr && (!aSelfReplace);
                }
                return bClmsStr && (!bSelfReplace);
            }

            async function doCompare() {
                const domResult = await vm.fromService.genCompareDom(vm.fromTextData.str, vm.toTextData.str, vm.fromService.lang);
                display.innerHTML = '';
                display.appendChild(domResult.fragment);
                vm.diffCount = domResult.totalDiffCount;
                const isSame = vm.toTextData.relatedPatentId && vm.fromTextData.relatedPatentId === vm.toTextData.relatedPatentId;
                if (isSame) {
                    vm.closeErrCompare('COMPARE_IDENTICAL');
                }
            }

            // 按照文档表格纯翻译过来 见图 ./compare_warn.png
            // https://confluence.zhihuiya.com/display/doc/Claims+compare+tool

            // 当前专利有文本并且非替代文本 && 对比的专利有文本并且非替代文本
            if (selfHas('a') && selfHas('b')) {
                await doCompare();
            // 当前专利有文本并且非替代文本 && 对比的专利替代文本是当前文本
            } else if (selfHas('a') && bSelfReplace === aSelfPid) {
                // 对比目标没有文本
                this.closeErrCompare('COMPARE_EMPTY');
                return;
            // 当前专利有文本并且非替代文本 && 对比的专利替代文本非当前专利 && 对比的专利有替代文本
            } else if (selfHas('a') && bSelfReplace !== aSelfPid && bSelfReplace !== bSelfPid) {
                await doCompare();
            // 当前专利的替代文本是对比的专利 && 对比的专利有文本并且非替代文本
            } else if (aSelfReplace === bSelfPid && selfHas('b')) {
                // 两篇文本来自同一篇专利
                this.closeErrCompare('COMPARE_SAME_PN');
                return;
            // 当前专利的替代文本不是对比专利的替代文本 && 当前专利文本为替代文本 && 对比的专利有文本并且非替代文本
            } else if (aSelfReplace !== bSelfReplace && aSelfReplace !== aSelfPid && selfHas('b')) {
                await doCompare();
            // 当前专利和对比专利替代文本相同
            } else if (aSelfReplace && bSelfReplace && aSelfReplace === bSelfReplace) {
                // 两篇文本来自同一篇专利
                this.closeErrCompare('COMPARE_SAME_PN');
                return;
            } else {
                await doCompare();
            }
            // 两篇专利文本内容相同
            if (this.diffCount === 0) {
                this.closeErrCompare('COMPARE_IDENTICAL');
                return;
            }

            vm.loading = false;
        },
    },
};
</script>

<style lang="scss">
    .claims-compare{
        min-height: calc(100vh - 300px);
        .identical {
            margin: 1em 0;
            text-align: center;
            color: $neutral-grey-70;
        }
    }
    .claims-compare pre{
        margin: 0;
        color: #061632;
        white-space: pre-wrap;
        font-family: inherit;
        font-size: inherit;
        .c-added{
            color: #1C8C03;
        }
        .c-removed {
            color: #D11932;
            text-decoration: line-through;
        }
    }
</style>
